import React from "react";
import { useTranslation } from "react-i18next";

function PrivacyPage() {
  const { t } = useTranslation("global");
  
  const privacySections = [
    { title: t("privacy.2"), content: t("privacy.2.2") },
    { title: t("privacy.3"), content: t("privacy.3.3") },
    { title: t("privacy.4"), content: t("privacy.4.4") },
    { title: t("privacy.5"), content: t("privacy.5.5") },
    { title: t("privacy.6"), content: t("privacy.6.6") },
    { title: t("privacy.7"), content: t("privacy.7.7") }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-b from-blue-800 to-blue-900 text-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="md:w-3/5 space-y-6">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold">
                {t("privacy.title")}
              </h1>
              <p className="text-xl text-blue-100">
                {t("privacy.subtitle", "Comment nous protégeons vos données personnelles")}
              </p>
              <div className="w-20 h-1 bg-blue-300"></div>
            </div>
            
            <div className="md:w-2/5">
              {/* Privacy Shield Design - Tailwind Only */}
              <div className="relative w-64 h-64 mx-auto">
                {/* Background elements */}
                <div className="absolute w-full h-full bg-blue-700 rounded-full opacity-20"></div>
                <div className="absolute w-4/5 h-4/5 bg-blue-600 rounded-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-30"></div>
                
                {/* Shield design */}
                <div className="absolute w-40 h-48 bg-blue-100 rounded-t-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 overflow-hidden">
                  {/* Shield inner design */}
                  <div className="absolute w-full h-full bg-gradient-to-b from-blue-200 to-blue-50"></div>
                  <div className="absolute w-32 h-36 bg-blue-300 rounded-t-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-30"></div>
                  
                  {/* Shield lock icon */}
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                </div>
                
                {/* Decorative elements */}
                <div className="absolute w-10 h-10 bg-blue-400 rounded-full -top-3 right-10 opacity-40"></div>
                <div className="absolute w-6 h-6 bg-blue-300 rounded-full top-1/4 -right-2 opacity-60"></div>
                <div className="absolute w-8 h-8 bg-blue-300 rounded-full bottom-0 left-10 opacity-50"></div>
                
                {/* Data protection symbols */}
                <div className="absolute top-6 left-6 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center transform rotate-12 shadow-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                
                <div className="absolute bottom-8 right-4 w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center transform -rotate-12 shadow-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                
                <div className="absolute top-1/2 -right-4 w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center transform rotate-45 shadow-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Introduction Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-blue-50 rounded-xl p-6 border-l-4 border-blue-500">
              <h2 className="text-2xl font-heading font-bold text-blue-900 mb-4">
                {t("privacy.introduction", "Introduction à notre politique de confidentialité")}
              </h2>
              <p className="text-gray-700">
                {t("privacy.introText", "Chez ISOeVAL, nous prenons la protection de vos données personnelles très au sérieux. Cette politique de confidentialité explique comment nous collectons, utilisons, partageons et protégeons vos informations personnelles lorsque vous utilisez notre plateforme.")}
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Privacy Content Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <div className="p-8">
                <div className="grid md:grid-cols-2 gap-8">
                  {privacySections.map((section, index) => (
                    <div key={index} className="bg-white border border-gray-100 rounded-lg p-6 hover:shadow-md transition-all duration-300">
                      <div className="flex items-center mb-4">
                        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                          <span className="text-blue-600 font-heading font-bold">{index + 1}</span>
                        </div>
                        <h3 className="text-xl font-heading font-bold text-blue-900">
                          {section.title}
                        </h3>
                      </div>
                      <div className="w-16 h-0.5 bg-blue-600 mb-4"></div>
                      <p className="text-gray-700">
                        {section.content}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Contact CTA Section */}
      <section className="py-12 bg-blue-700 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl font-heading font-bold mb-4">
              {t("privacy.questions", "Vous avez des questions sur notre politique de confidentialité?")}
            </h2>
            <p className="text-blue-100 mb-8">
              {t("privacy.contactUs", "Si vous avez des questions concernant la façon dont nous traitons vos données, n'hésitez pas à nous contacter.")}
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="contact"
                className="bg-white text-blue-700 hover:bg-blue-50 py-3 px-8 rounded-full font-heading font-bold transition-all"
              >
                {t("contact.contact")}
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PrivacyPage;